import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';

import './Paginator.scss';

class Paginator extends Component {
  handlePageChange = (data) => {
    this.props.paginate(data.selected + 1);
  };

  renderPagers = () => {
    if (this.props.totalPages <= 1) return null;

    return (
      <ReactPaginate
        previousLabel="‹ Prev"
        nextLabel="Next ›"
        breakLabel={<a href="#">...</a>}
        breakClassName="break-me"
        pageCount={this.props.totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={this.handlePageChange}
        activeClassName="active"
        forcePage={this.props.forcePage}
      />
    );
  };

  render() {
    return <div className="paginator">{this.renderPagers()}</div>;
  }
}

export default Paginator;
